import { z } from 'zod';

import { CatalogItemStatusSchema } from './catalog-item-status.schema.js';

export const ChangeServiceStatusBodySchema = z.object({
  status: CatalogItemStatusSchema,
  reason: z.string().trim().max(500).optional(),
});

export type ChangeServiceStatusBody = z.infer<typeof ChangeServiceStatusBodySchema>;
